import { IDAssume } from 'subscription/components/shared/edit-data/assume-list';
import { IDRequested } from 'subscription/components/shared/edit-data/requested-list';
import { IDSubscribeTo } from 'subscription/components/shared/edit-data/subscribe-to-list';
import { ID_SURNAME_TYPE } from 'civil-status/constants/id-surname-type';
import { ModelEventoDTO, SubjectAnpr } from 'shell/models/act-category-list';
import { EditDataControl } from 'subscription/view-models/common-interface-subscription';
import { DateTime } from 'luxon';
import { IDFlags } from 'shell/components/shared/flag-validation-fiscal-code/flag';

const subscribeToValue = (
  isCohabitation?: boolean,
  isOther?: boolean,
  isMother?: boolean,
  isFather?: boolean
): string => {
  if (isMother) {
    return IDSubscribeTo.Madre;
  }

  if (isFather) {
    return IDSubscribeTo.Padre;
  }

  if (isCohabitation) {
    return IDSubscribeTo.Convivenza;
  }

  if (isOther) {
    return IDSubscribeTo.Altra;
  }

  return IDSubscribeTo.Genitori;
};

const requestedValue = (isMother?: boolean, isFather?: boolean): string => {
  if (isMother && isFather) {
    return IDRequested.Genitori;
  }
  if (isMother) {
    return IDRequested.Madre;
  }

  if (isFather) {
    return IDRequested.Padre;
  }

  return IDRequested.Nessuno;
};

export const transformEditDataControl = (
  modelEventoDTO: ModelEventoDTO,
  isCohabitation?: boolean,
  isOther?: boolean,
  isMotherAct?: boolean,
  isFatherAct?: boolean,
  intestatario?: SubjectAnpr
): EditDataControl => {
  const sceltaCognome = modelEventoDTO.datiDiNascita?.sceltaCognome;

  const isMother =
    Boolean(modelEventoDTO.madre) &&
    Boolean(modelEventoDTO.madre?.nome) &&
    Boolean(modelEventoDTO.madre?.cognome);
  const isFather =
    Boolean(modelEventoDTO.padre) &&
    Boolean(modelEventoDTO.padre?.nome) &&
    Boolean(modelEventoDTO.padre?.cognome);

  return {
    dateValidity: intestatario?.dataNascita
      ? DateTime.fromISO(intestatario.dataNascita)
      : DateTime.now(),
    subscribeTo: subscribeToValue(isCohabitation, isOther, isMotherAct, isFatherAct),
    requested: requestedValue(isMother, isFather),
    assume:
      sceltaCognome === ID_SURNAME_TYPE.Madre
        ? IDAssume.Madre
        : sceltaCognome === ID_SURNAME_TYPE.Padre
        ? IDAssume.Padre
        : sceltaCognome === ID_SURNAME_TYPE.MadrePadre ||
          sceltaCognome === ID_SURNAME_TYPE.PadreMadre
        ? IDAssume.Entrambi
        : IDAssume.Altro,
    flag: IDFlags.Nessuna,
  };
};
